import axios from 'axios';
import { RetrospectiveData } from '../../types';
import { PACOCA_API_URL } from '../../global-components/src/utils/vars';

export interface RetrospectiveShare {
  year: number;
  url: string;
}

export async function getRetrospective(token: string, year?: number): Promise<RetrospectiveData> {
  const { data } = await axios.get<RetrospectiveData>(`${PACOCA_API_URL}/retrospective`, {
    params: year ? { year } : undefined,
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function createRetrospectiveShare(token: string, year: number): Promise<RetrospectiveShare> {
  const { data } = await axios.post<RetrospectiveShare>(`${PACOCA_API_URL}/retrospective/share`, { year }, {
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function getSharedRetrospective(userId: number, year: number, signature: string): Promise<RetrospectiveData> {
  const { data } = await axios.get<RetrospectiveData>(`${PACOCA_API_URL}/retrospective/shared/${userId}/${year}`, {
    params: { signature },
    headers: { Accept: 'application/json' },
  });
  return data;
}
